import PropTypes from 'prop-types';
import React from 'react';

const NotFound = ({children}) => (
    <div className="valign-wrapper">
        <h5 className="center-align">{children}</h5>
    </div>
);

NotFound.propTypes = {
    children: PropTypes.string.isRequired,
};

export default NotFound;



// WEBPACK FOOTER //
// ./scripts/components/NotFound.js